// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"702":"f4ba0957","954":"a9c71a1e"}[chunkId] + ".chunk.css";
};